import { Controller } from '@hotwired/stimulus'
import StatusesTransitionsController from '../statuses_transitions_controller'
import DynamicSelect, { Options } from '../../modules/dynamic_select'

export default class extends Controller {
  static targets = ['status', 'statusSelect']
  static values = { options: Array, default: [] }

  declare readonly statusTargets: HTMLInputElement[]
  declare selectboxes: DynamicSelect[]
  declare optionsValue: Options

  private statusesTransitionsController: StatusesTransitionsController

  connect (): void {
    this.statusesTransitionsController = new StatusesTransitionsController(this.context)

    this.collectOptions = this.statusesTransitionsController.collectOptions.bind(this)
    this.optionsValueChanged = this.statusesTransitionsController.optionsValueChanged.bind(this)
  }

  collectOptions (): void {
    this.collectOptions()
  }

  optionsValueChanged (): void {
    this.optionsValueChanged()
  }
}
